import investorAnnouncementsResolver, {
    ResolvedInvestorAnnouncements,
} from "resolvers/data/investorAnnouncementsResolver";
import staticCardResolver, { ResolvedStaticCard } from "resolvers/data/staticCardResolver";
import { SharePrice } from "services/cms/models";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import { InvestorAnnouncements } from "services/cms/models/investorAnnouncements";
import { StaticCard } from "services/cms/models/staticCard";
import { StaticPageComponentWrapper } from "services/cms/models/staticPageComponentWrapper";
import type {
    IContentItem,
    IContentItemElements,
    IContentItemsContainer,
} from "services/content-manager/models";

import sharePriceResolver, { ResolvedSharePrice } from "./sharePriceResolver";

export interface ResolvedStaticPageComponentWrapper {
    resolvedItems: ResolvedItem[];
    codename: string;
    type: ContentTypeCodenames.StaticPageComponentWrapper;
}

export type ResolvedItem = ResolvedStaticCard | ResolvedInvestorAnnouncements | ResolvedSharePrice;

const getResolvedItem = (item: IContentItem): ResolvedItem | null => {
    switch (item.system?.type) {
        case ContentTypeCodenames.SharePrice:
            return sharePriceResolver(item as SharePrice);
        case ContentTypeCodenames.StaticCard:
            return staticCardResolver(item as StaticCard, true, false);
        case ContentTypeCodenames.InvestorAnnouncements:
            return investorAnnouncementsResolver(item as InvestorAnnouncements);
        default:
            return null;
    }
};

const staticPageComponentWrapperResolver = (
    data: StaticPageComponentWrapper
): ResolvedStaticPageComponentWrapper => {
    if (!data.elements.components) {
        return {
            resolvedItems: [],
            codename: data.system.codename,
            type: ContentTypeCodenames.StaticPageComponentWrapper,
        };
    }

    let actualLinkedItems = data.elements.components.linkedItems as
        | IContentItemsContainer
        | IContentItem<IContentItemElements>[];

    const resolvedItems = Object.values(actualLinkedItems)
        .map((item) => getResolvedItem(item))
        .filter((value) => value) as ResolvedItem[];

    return {
        resolvedItems,
        codename: data.system.codename,
        type: ContentTypeCodenames.StaticPageComponentWrapper,
    };
};

export default staticPageComponentWrapperResolver;
